import * as React from 'react'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'

export interface SearchFloatingPanelProps {
  title: string
  isOpen?: boolean
  children: React.ReactNode
  confirmText?: string
  onConfirm?: () => void
  onClose: () => void
  onGoBack: () => void
  isConfirmButtonHidden?: boolean
  confirmButtonDisabled?: boolean
  confirmButtonStartIcon?: React.ReactElement
  secondaryActionText?: string
  onSecondaryActionClick?: () => void
  secondaryButtonDisabled?: boolean
  footerContent?: React.ReactNode
}

const SearchFloatingPanel = React.forwardRef<HTMLDivElement, SearchFloatingPanelProps>((props, ref) => {
  const {
    title,
    isOpen,
    confirmText,
    onConfirm,
    onClose,
    onGoBack,
    children,
    isConfirmButtonHidden,
    confirmButtonDisabled,
    confirmButtonStartIcon,
    secondaryActionText,
    onSecondaryActionClick,
    secondaryButtonDisabled,
    footerContent,
  } = props

  const primaryActionProps = React.useMemo(() => ({
    children: confirmText,
    disabled: confirmButtonDisabled,
    onClick: onConfirm,
    startIcon: confirmButtonStartIcon,
  }), [confirmButtonDisabled, confirmButtonStartIcon, confirmText, onConfirm])

  const secondaryActionProps = React.useMemo(() => ({
    children: secondaryActionText,
    onClick: onSecondaryActionClick,
    disabled: secondaryButtonDisabled,
  }), [onSecondaryActionClick, secondaryActionText, secondaryButtonDisabled])

  return (
    <ModalBase
      mode="drawer"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalHeader
        title={title}
        onBackButtonClick={onGoBack}
        onCloseButtonClick={onClose}
      />
      <ModalBody ref={ref}>
        <ModalContent flushListItems>
          {children}
        </ModalContent>
      </ModalBody>
      {(confirmText || secondaryActionText || footerContent) && (
        <ModalFooter
          isPrimaryActionHidden={isConfirmButtonHidden}
          primaryActionProps={primaryActionProps}
          secondaryActionProps={secondaryActionProps}
        >
          {footerContent}
        </ModalFooter>
      )}
    </ModalBase>
  )
})

SearchFloatingPanel.displayName = 'SearchFloatingPanel'

export default SearchFloatingPanel
